import { render } from "./periods-picker.vue?vue&type=template&id=8b3af890&scoped=true&ts=true"
import script from "./periods-picker.vue?vue&type=script&lang=ts"
export * from "./periods-picker.vue?vue&type=script&lang=ts"

import "./periods-picker.vue?vue&type=style&index=0&id=8b3af890&lang=scss&scoped=true"

import exportComponent from "/app/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-8b3af890"]])

export default __exports__